import { DataImportState } from '../../models';

export const dataImportInitialState: DataImportState = {
  selection: {}
};
